module.exports = __webpack_public_path__ + "img/popup-btn-guest.1797eec.png";